/**
 * Created by m.igrachev on 7/21/2017.
 */
import Validator from "validator";

export default function(toValidate) {
    //do not need to check undefined and empty string
    if (!toValidate || toValidate === "") {
        return true;
    }
    return Validator.isEmail(toValidate);
}
